import 'react-toastify/dist/ReactToastify.min.css'
import { ToastContainer as RTToastContainer } from 'react-toastify'
import styled from 'styled-components'
import colors from 'constants/colors'

export const ToastContainer = styled(RTToastContainer)`
  font-family: Poppins;

  .Toastify__toast--dark {
    background-color: ${colors.primaryDark};
  }
  .Toastify__toast--default {
    background-color: ${colors.primary};
  }
  .Toastify__toast--info {
    background-color: ${colors.primary};
  }
  .Toastify__toast--success {
    background-color: ${colors.primary};
  }
  .Toastify__toast--warning {
    background-color: ${colors.error};
  }
  .Toastify__toast--error {
    background-color: ${colors.error};
  }
`
